import { WorkflowStepFormFieldBlock } from '../../types';
import { filterBlocksOfType } from './filterBlocksOfType';

export const getFlattenedFormFieldBlocks = (
  formFieldBlocks: WorkflowStepFormFieldBlock[],
): WorkflowStepFormFieldBlock[] =>
  formFieldBlocks.reduce((allBlocks, block) => {
    let additionalBlocks: WorkflowStepFormFieldBlock[] = [];
    if (block.componentProps?.footer) {
      additionalBlocks = filterBlocksOfType(
        block.componentProps.footer.blocks,
        'form-field',
      );
    }
    return [...allBlocks, block, ...additionalBlocks];
  }, [] as WorkflowStepFormFieldBlock[]);
